import { browserTimezone, convertToTimezone } from "@gigpro/utils/datetime";
import { produce } from "immer";
import { useEventsShiftsList } from "../../generated/events/events";
import type { GigShiftSerializerWithGigs } from "../../generated/model/gigShiftSerializerWithGigs";
import { composeSelect } from "../types";

const applyTzToShift = produce<GigShiftSerializerWithGigs>((draft) => {
  const tz = draft.location.timezone ?? browserTimezone;
  draft.start_time = convertToTimezone(draft.start_time, tz);
  draft.end_time = convertToTimezone(draft.end_time, tz);
});

export const zoneAndSortShifts = (shifts: Array<GigShiftSerializerWithGigs>) =>
  shifts.map(applyTzToShift).toSorted((a, b) => a.start_time.getTime() - b.start_time.getTime());

export function useEventsShiftsListWithTransform<TData = Array<GigShiftSerializerWithGigs>>(
  ...[eventId, params, options]: Parameters<typeof useEventsShiftsList<TData>>
) {
  return useEventsShiftsList<TData>(eventId, params, {
    ...options,
    query: { ...options?.query, select: composeSelect(zoneAndSortShifts, options?.query?.select) },
  });
}
